var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 45 45"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19379",
  transform: "translate(-1403 -523)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.5,
  fill: "none",
  "data-name": "Ellipse 1555",
  transform: "translate(1403 523)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15192"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M1411 531h30v30h-30z",
  "data-name": "Rectangle 6440"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15185"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 15184",
  transform: "translate(1413.579 537.109)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.486 1.22A5.24 5.24 0 0 0 15.127 0H9.715a5.24 5.24 0 0 0-3.36 1.22 4.8 4.8 0 0 1-2.719 1.1l-.311.022A3.586 3.586 0 0 0 0 5.921V12.3a5.48 5.48 0 0 0 5.482 5.482H19.36a5.48 5.48 0 0 0 5.482-5.482V5.921a3.587 3.587 0 0 0-3.326-3.577l-.31-.022a4.8 4.8 0 0 1-2.72-1.102",
  "data-name": "Path 16561"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.644,
  cy: 5.644,
  r: 5.644,
  "data-name": "Ellipse 1485",
  transform: "translate(6.776 3.247)"
})))))));
export { SvgCamera as ReactComponent };
export default __webpack_public_path__ + "static/media/camera.49ecb318909dd0d4cf147dc3986f1de0.svg";